import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import SiteCard from "./SiteCards";
import Particle from "../Particle";
import onlyFans from "../../Assets/Sites/onlyfans.png";
import bestFans from "../../Assets/Sites/bestfans.jpg";
import telegram from "../../Assets/Sites/telegram.png";
//import onlyFansFree from "../../Assets/Sites/onlyfansfree.png";
//import fansyme from "../../Assets/Sites/fansyme.png"
//import snapselltelegram from "../../Assets/Sites/snapselltelegram.png";
import fanSeven from "../../Assets/Sites/fanseven.png";
//import fourBased from "../../Assets/Sites/4based.png";
//import fancci from "../../Assets/Sites/fancci.png";
//import mym from "../../Assets/Sites/mym.png"; 
//import fansly from "../../Assets/Sites/fansly.png"; 
// import snapsell from "../../Assets/Sites/snapsell.png"
import { useTranslation } from "react-i18next";

function Sites() {
  const { t } = useTranslation();
  return (
    <Container fluid className="Site-section">
      <Particle />
      <Container>
        <h1 className="Site-heading">
          {t("my")} {t("site")}
        </h1>
        <p className="purple-text">{t("more")}</p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="Site-card">
            <SiteCard
              imgPath={bestFans}
              isBlog={false}
              title="BestFans"
              demoLink="https://www.bestfans.com/lialove"
            />
          </Col>
          <Col md={4} className="Site-card">
            <SiteCard
              imgPath={onlyFans}
              isBlog={false}
              title="OnlyFans"
              demoLink="https://onlyfans.com/u577038193"
            />
          </Col>
          <Col md={4} className="Site-card">
            <SiteCard
              imgPath={fanSeven}
              isBlog={false}
              title="Fanseven"
              demoLink="https://fanseven.com/l/lia"
            />
          </Col>            
          <Col md={4} className="Site-card">
            <SiteCard
              imgPath={telegram}
              isBlog={false}
              title="Telegram"
              demoLink="https://t.me/+aaCgA-IcIJk0NmUy"
            />
          </Col>       
        </Row>
      </Container>
    </Container>
  );
}

export default Sites;
